import { Image } from 'lib'

import client_logo from "assets/images/Kotak_Mahindra_Bank_logo.png"
import Sign_desk_logo from "assets/images/signdesk_logo.svg"
import './index.scss';

const LoginPage = (props) => {
  
  const {children} = props

  return (
    <>
      <Image imageSrc={client_logo} className="logo" />
      <div className='login'>
        <div className='login_card'>
          {children}
        </div>
      </div>
      <div className='signdesk_logo'>
        <p>Powered by</p>
        <Image imageSrc={Sign_desk_logo} alt="signDesk_logo" />
      </div>
    </>
  )
}

export default LoginPage